import { render, staticRenderFns } from "./RequestFeedTable.vue?vue&type=template&id=f6bdbfb0&"
import script from "./RequestFeedTable.vue?vue&type=script&lang=js&"
export * from "./RequestFeedTable.vue?vue&type=script&lang=js&"
import style0 from "./RequestFeedTable.vue?vue&type=style&index=0&id=f6bdbfb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports